import MobileNavigation from './mobile-navigation';
import Header from "./header"
import { useState } from 'react';
import GoToTopIcon from '@components/icons/go-to-top-icon';
import Scroll from 'react-scroll';
import cn from 'classnames';
import GaAnalysis from "@components/layouts/ga-analysis";
import { useEffect } from 'react';
import { isMobileOnly, isTablet, isIOS } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { setCheckDeviceSettings, setForwardPath, } from '@framework/app/settingsSlice';
import router from 'next/router';
import Clarity from "@components/layouts/clarity";
import { useModalAction } from '@components/ui/modal/modal.context';
import { usePolicyQuery } from '@framework/customer/customer.query';
import { RootState } from 'src/root-redux/store';

const SiteLayoutMobile: React.FC = ({ children }) => {
  const scroll = Scroll.animateScroll;
  const [scrollY, setScrollY] = useState(0);
  const { innerHeight } = window;
  const dispatch = useDispatch();
  const { isAuthorize, currentUser: me } = useSelector((state: RootState) => state.authenticationSettings);
  const { i33Settings: { isSkipPolicyUser } } = useSelector((state: RootState) => state);

  useEffect(() => {
    dispatch(setCheckDeviceSettings({
      isMobileOnly,
      isTablet,
      isIOS
    }));
    dispatch(setForwardPath(router.asPath))
  }, []);

  // document.onkeydown = function (e) {
  //   if(e.key == "F12") {
  //     return false;
  //   }

  //   if((e.ctrlKey || e.metaKey) && e.shiftKey && e.key == "c") {
  //     return false;
  //   }
  // }

  // document.addEventListener("contextmenu", function (e) {
  //   e.preventDefault();
  // }, false);

  window.addEventListener("scroll", (event) => {
    setScrollY(window.scrollY);
  });
  const { openModal } = useModalAction();
    const {
      data,
      isLoading: loading,
      error,
    } = usePolicyQuery({
      enabled: isAuthorize && me.policy_agreements.length == 0,
      staleTime: Infinity,
    });
  useEffect(() => {
    if(!isSkipPolicyUser && isAuthorize && me.policy_agreements.length == 0 && data) {
      openModal('POLICY_POPUP');
    }
  }, [isSkipPolicyUser, isAuthorize, me, data]);
  return (
    <div className="flex flex-col min-h-screen transition-colors duration-150 bg-gray-full">
      <GaAnalysis />
      <Clarity />
      {children}
      <div className='hidden'><Header /></div>
      <MobileNavigation />

      <div className={cn('fixed right-[15px] sm:right-6 bottom-20 sm:bottom-6 py-2 px-3 rounded-[15px] bg-accent hover:bg-accent-hover cursor-pointer z-[200] opacity-0',
        scrollY > (innerHeight / 3) ? "fade-in" : "fade-out"
      )} onClick={() => scroll.scrollToTop()}>
        <GoToTopIcon />
      </div>
    </div>
  );
};

export const getLayout = (page: React.ReactElement) => (
  <SiteLayoutMobile>{page}</SiteLayoutMobile>
);

export default SiteLayoutMobile;
